import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";
import type {
  FacebookPageResponse,
  FacebookPagesListResponse,
  FacebookPageTokenStatusResponse,
  FacebookRefreshTokensResponse,
  FacebookSetupInfo,
  WebhookActivityResponse,
} from "./types";

const base = `${config.apiUrl}/facebook`;

export const facebookApi = {
  setup(): Promise<FacebookSetupInfo> {
    return fetcher.get(`${base}/setup`);
  },

  listPages(): Promise<FacebookPagesListResponse> {
    return fetcher.get(`${base}/pages`);
  },

  getPage(id: string): Promise<FacebookPageResponse> {
    return fetcher.get(`${base}/pages/${id}`);
  },

  connectPage(id: string): Promise<FacebookPageResponse> {
    return fetcher.post(`${base}/pages/${id}/connect`);
  },

  disconnectPage(id: string): Promise<FacebookPageResponse> {
    return fetcher.post(`${base}/pages/${id}/disconnect`);
  },

  tokenStatus(id: string): Promise<FacebookPageTokenStatusResponse> {
    return fetcher.get(`${base}/pages/${id}/token-status`);
  },

  refreshTokens(): Promise<FacebookRefreshTokensResponse> {
    return fetcher.post(`${base}/pages/refresh-tokens`);
  },

  webhookActivity(
    params: { limit?: number; facebookPageId?: string } = {},
  ): Promise<WebhookActivityResponse> {
    const url = new URL(`${base}/webhook-activity`);
    if (params.limit) url.searchParams.set("limit", String(params.limit));
    if (params.facebookPageId)
      url.searchParams.set("facebookPageId", params.facebookPageId);
    return fetcher.get(url.toString());
  },
};

/** เริ่ม OAuth — ขอ URL จาก API แล้ว redirect (หลีกเลี่ยงหน้าขาวจาก set.redirect) */
export async function redirectToFacebookOAuth(
  redirectPath = "/app/facebook",
): Promise<void> {
  const url = new URL(`${base}/auth/start`);
  url.searchParams.set("redirect", redirectPath);
  url.searchParams.set("format", "json");

  const data = await fetcher.get<{ authorizationUrl?: string }>(url.toString());
  if (!data.authorizationUrl) {
    throw new Error("Missing authorizationUrl from server");
  }
  window.location.href = data.authorizationUrl;
}
